import { Component, OnInit, Input, effect } from '@angular/core';
import { registerSparkComponents } from 'genesys-spark';

import { AdmissionUIMessengerService } from '../admission-ui-messenger.service';
import { AdmissionUICommonDataService } from '../admission-ui-common-data.service';

import { Student, UIConfiguration, AdmissionsService, PlaceOutbountCallRequest, UserService, DialerContactService } from '../../../lib';
import { LeadConversationState, LeadConversationStateStore } from '../../dialpad/leadConversation.state';
import { ToastService } from '../../toast/toast.service';

@Component({
  selector: 'app-multiple-match-screen',
  templateUrl: './multiple-match-screen.component.html',
  styleUrl: './multiple-match-screen.component.scss'
})

export class MultipleMatchScreenComponent implements OnInit {
  @Input() buttonType: string = 'primary';
  @Input() previousUserCallStatus: string = 'Available';
  @Input() callSkills: string[] = [];

  phoneNumber: string = '';
  studentData: Student[] = [];
  filteredStudentData: Student[] = [];
  inquiryId: number | undefined;
  dialerContactId: number | undefined;
  conversationId: string | null = null;
  emailConversationId: string | null = null;
  callType: string = 'OutgoingCall';

  uiConfiguration: UIConfiguration[] | undefined;
  DispWindowShowForSchoolStatuses: string | null | undefined = null;
  StitchWindowShowForSchoolStatuses: string | null | undefined = null;

  selectedItem = -1;

  isLoading: boolean = true;
  private leadConversationState: LeadConversationState = {};
  selectButtonDisable: boolean = false;
  isLeadUserInterface: boolean | undefined = undefined;
  isAdmissionsCompliance: boolean | undefined = undefined;

  constructor(
    private readonly commonDataService: AdmissionUICommonDataService,
    private readonly messenger: AdmissionUIMessengerService,
    private readonly admissionsService: AdmissionsService,
    private readonly userService: UserService,
    private readonly dialerService: DialerContactService,
    private readonly leadConversationStateStore: LeadConversationStateStore,
    private readonly toastService: ToastService

  ) {
    this.isAdmissionsCompliance = localStorage.getItem('isAdmissionCompliance') == null ? undefined : localStorage.getItem('isAdmissionCompliance') === 'true';
    this.isLeadUserInterface = localStorage.getItem('isLeadUserInterface') === 'true';
    effect(() => {
      this.leadConversationState = this.leadConversationStateStore.getState()();
      this.phoneNumber = this.leadConversationState.PhoneNumber ?? '';
      this.callType = this.leadConversationState.CallType ?? 'OutgoingCall';
      this.previousUserCallStatus = this.leadConversationState?.PreviousUserStatus ?? "Available";
    });
  }

  ngOnInit() {
    registerSparkComponents().then(() => {
      this.isLoading = false;
    });


    this.commonDataService.multiStudentData.subscribe(multiStudentData => {
      this.studentData = multiStudentData;
      if (this.callType === 'OutgoingCall') {
        this.filteredStudentData = this.studentData.filter(student =>
          student.phone !== null && student.phone !== undefined && student.phone !== 'Do Not Call'
        );
        if (this.filteredStudentData.length < 1) {
          this.leadConversationStateStore.endInteraction(this.phoneNumber)
        }
      } else {
        this.filteredStudentData = this.studentData.filter(student =>
          student.phone !== null && student.phone !== undefined
        );
      }
      this.filteredStudentData.sort((a: any, b: any) => new Date(b.leadDate).getTime() - new Date(a.leadDate).getTime());
    });

    this.commonDataService.getUIConfigurationAndSchoolStatuses().subscribe(data => {
      this.uiConfiguration = data.uiConfiguration;
      this.DispWindowShowForSchoolStatuses = data.DispWindowShowForSchoolStatuses;
      this.StitchWindowShowForSchoolStatuses = data.StitchWindowShowForSchoolStatuses;
    });
  }

  formatPhoneNumber(phoneNumber: string): string {
    if (phoneNumber && phoneNumber.length === 10) {
      return `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`;
    } else {
      return phoneNumber;
    }
  }

  studentSelected(index: number) {
    this.selectedItem = index;
  }

  selectButtonClicked(): void {
    this.selectButtonDisable = true;
    const student: Student = this.filteredStudentData[this.selectedItem];
    this.leadConversationStateStore.updateStudent(student);
    if (student.schoolStatus?.code) {
      if (this.isLeadUserInterface && this.DispWindowShowForSchoolStatuses?.includes(student.schoolStatus.code)) {
        this.sendToDispositionScreen();
      } else if (this.isLeadUserInterface && this.StitchWindowShowForSchoolStatuses?.includes(student.schoolStatus.code)) {
        this.messenger.setPage('StichIn');
        this.commonDataService.setIsStitchIn(true);
        this.commonDataService.setPreviousUserStatus(this.previousUserCallStatus);
      } else if (this.callType === 'OutgoingCall') {
        this.multimatchDial(student)
        //KENT - do we need to deal with this case? 
      }
      else {
        this.sendToDispositionScreen();
      }
    }
  }

  sendToDispositionScreen(): void {
    if (this.isLeadUserInterface) {
      this.messenger.setPage('Disposition');
      this.commonDataService.setPreviousUserStatus(this.previousUserCallStatus);
    } else {
      this.messenger.setPage('Idle');
    }
  }

  formatDate(srcDate: string | null | undefined): string {
    if (srcDate === null || srcDate === undefined) {
      return '';
    } else {
      // Ensure consistent parsing by appending T00:00:00
      let date: Date;
      if (/^\d{4}-\d{2}-\d{2}$/.test(srcDate)) {
        date = new Date(srcDate + 'T00:00:00');
      } else {
        date = new Date(srcDate);
      }
      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      } else {
        return ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear();
      }
    }
  }

  multimatchDial(student: Student): void {
    this.inquiryId = student.inquiries?.find(obj => obj.isCurrent === true)?.id;
    const phoneNumber = this.leadConversationState.PhoneNumber;
    this.userService.apiAccountGet().subscribe(accountData => {
      if (this.inquiryId !== undefined && phoneNumber !== undefined) {
        this.dialerService.apiDialerContactGetByInquiryIdGet(this.inquiryId).subscribe(data => {
          this.dialerContactId = data.id;
          if (this.dialerContactId !== undefined && accountData.id !== undefined && this.inquiryId && phoneNumber) {
            const placeOutboundCallRequest = {
              syStudentId: student.id,
              phoneNumber: phoneNumber,
              isLocalTouch: this.commonDataService.localTouch,
              syStudentInquiryId: this.inquiryId,
              dialerContactId: this.dialerContactId,
              accountId: accountData?.id,
              telecomInteractionType: PlaceOutbountCallRequest.TelecomInteractionTypeEnum.NUMBER_null4, //KENT - Fix this
              participantId: null,
              conversationId: this.emailConversationId || this.conversationId
            };
            this.admissionsService.apiAdmissionOutboundCallPlaceCallPost(placeOutboundCallRequest).subscribe({
              next: (data) => {
                if (this.isLeadUserInterface) {
                  this.leadConversationStateStore.endInteraction(placeOutboundCallRequest.phoneNumber, undefined, false);
                }
                if (!data?.id) {
                  this.messenger.setSetDialpadMessageNotification('Call failed - ' + data?.error);
                  this.leadConversationStateStore.endInteraction(placeOutboundCallRequest.phoneNumber);
                } else {
                  this.messenger.setPage('Idle');
                  this.leadConversationStateStore?.clearState();
                  this.messenger.clearLocalStorageState();
                }
              },
              error: err => {
                const errMsg = err?.message || 'Call failed';
                this.toastService.show({
                  body: errMsg,
                  classname: 'bg-danger text-light',
                  delay: 5000,
                  header: 'Dial Failed'
                });
                this.commonDataService.toggleUserStatus(this.previousUserCallStatus).subscribe(() => { });
                this.leadConversationStateStore.endInteraction(placeOutboundCallRequest.phoneNumber);
              }
            });
          }
        });
      }
    });
  }
}
